/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./tableList.vue?vue&type=template&id=2e52faaf&"
import script from "./tableList.vue?vue&type=script&lang=js&"
export * from "./tableList.vue?vue&type=script&lang=js&"
import style0 from "./tableList.vue?vue&type=style&index=0&id=2e52faaf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports